/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { logger as log } from '@common/logger';

import { Client, Provider, cacheExchange, fetchExchange } from 'urql';
import { Graphql } from '@common/graphql';
import { Sttp } from '@common/sttp';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator';
import { apiConfig } from '@pages/AdminPage/config/api.config';
import { inviteUserConfig } from '@pages/AdminPage/config/inviteUser.config';
import { INVITE_CREDIT_UNION_USER } from '@pages/AdminPage/api/graphql';
import { StorageModule } from '@vlinder-web/storage-module-react';

const getStorageSrv = StorageModule?.getInstance();
const getWhoamiSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface InviteUserProps {
  email: string;
  firstName: string;
  lastName: string;
  invite: boolean;
  userRoles: boolean;
  loginRestAPI: string;
  headers: any;
  termsOfUse: any;
}

export interface IInviteUserPluginMethods extends IPluginMethodMap {
  getInviteUserSync(args?: any): any;
}

export class InviteUserPlugin implements IAgentPlugin {
  readonly methods: IInviteUserPluginMethods;

  constructor() {
    this.methods = {
      getInviteUserSync: this.getInviteUserSync.bind(this),
    };
  }

  async getInviteUserSync(args?: InviteUserProps) {
    //  await new Promise((r) => setTimeout(r, 2000));
    return await this.inviteUser(args);
    //   return {
    //    inviteUser:inviteUserConfig
    //  };
  }

  //Graphql Query example
  async inviteUser(args?: any) {
    console.log('argss', args);
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    const token = getWhoamiSrv()?.getToken();
    //const token = null;
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();
    try {
      if (client) {
        const res = await client.mutation(
          INVITE_CREDIT_UNION_USER,
          {
            input: {
              invite:
                args?.termsOfUse && args?.termsOfUse[0] === 'inviteUser'
                  ? true
                  : false,
              user: {
                firstName: args?.firstName,
                lastName: args?.lastName,
                email: args?.email,
              },
              org: this.getOrgnizationId(),
              role: await this.getRole(args?.userRoles),
            },
          }
          // log.log('result of update profile=', res?.data?.capsules);
        );
      }
    } catch (err: any) {
      log.error('error in activate User', err?.message);
      throw err;
    }
  }

  private getOrgnizationId() {
    let orgId = getStorageSrv?.get('myProfile', 'session')?.org?.orgId;
    return orgId;
  }

  private async getRole(roles: any) {
    console.log(`roles:`, roles);
    let adminRole =
      Array.isArray(roles) && roles?.find((item) => item?.name === 'admin');
    console.log(`admin Role`, adminRole);
    return adminRole?.uuid;
    // const user = await getWhoamiSrv()?.whoAmI();
    // if(user?.whoami === "RISK_CAPITAL"){
    //   return null
    // }
    // else{
    //   return null
    // }
  }
}
